import styled from 'styled-components';

// CONSTANTS
import { WHITE, ROYAL_BLUE_2 } from '@/constants/colors';

export const Container = styled.div`
  padding-top: 40px;
  padding-bottom: 40px;

  .section-manager {
    &__title {
      margin-bottom: 16px;
    }

    &__link-genres {
      display: block;
      padding: 32px 16px;
      background-color: ${WHITE};
      text-align: center;
      border-radius: 8px;
      font-size: 18px;
      font-weight: 400;
      line-height: 30px;
    }

    &__link {
      margin-top: 36px;
      color: ${ROYAL_BLUE_2};
      text-align: center;
    }

    &__link-icon {
      font-size: 28px;
      line-height: 14px;
      margin-bottom: -8px;
      margin-left: -5px;
    }
  }

  .section-manager {
    &-apps {
    }

    &-channels {
    }

    &-shows-movies {
    }
  }

  &.section-manager {
    &-apps {
    }

    &-channels {
    }

    &-shows-movies {
    }
  }
`;

export default Container;
